import type { useAvailableResources } from "../hook/useAvailableResources";

export function getAvailableResourceKind(
  availableResources: ReturnType<typeof useAvailableResources>,
  identifier: string,
) {
  if (availableResources.quantity.identifiers.some(i => i.name === identifier))
    return availableResources.quantity.kind;
  if (availableResources.fault.identifiers.some(i => i.name === identifier))
    return availableResources.fault.kind;
  if (availableResources.system.identifiers.some(i => i.name === identifier))
    return availableResources.system.kind;
  if (availableResources.aggregate.identifiers.some(i => i.name === identifier))
    return availableResources.aggregate.kind;
  return null;
}
